import React, { useState } from 'react'
import { Icon , Button, Text, TextField } from '../../html'
import './LoginBox.css'

/**
 * Login Box
 */
export const LoginBox = ({
    logo, title,
    userLabel = "User",
    userValue = "",
    passwordLabel = "Password",
    passwordValue = '',
    loginLabel = "Log In", onOK,
    forgotLabel = "Forgot Password ?", onForgot,
    message,
    loading
}) => {

    const [user, setUser] = useState(userValue)
    const [password, setPassword] = useState(passwordValue)

    function canOK() {
        return user && user.length > 0 && password && password.length > 0
    }

    function ok(forcedPwd) {
        if (onOK && canOK()) onOK(user, forcedPwd || password)
    }

    function canForgot() {
        return user && user.length > 0
    }

    function forgot() {
        if (onForgot) onForgot(user)
    }

    function tx(txt) {
        return <Text>{txt}</Text>
    }

    function changeUser(id, value) {
        setUser(value)
    }
    
    function changePassword(id, value) {
        setPassword(value)
    }

    return (
        <div className="login-box">
            <header>
                {logo ? <img src={logo} /> : ''}
                <div className="title"><Text>{title}</Text></div>
            </header>
            <main>
                <TextField label={tx(userLabel)} value={user} onChange={changeUser} onEnter={ok} outlined />
                <TextField label={tx(passwordLabel)} value={password} onChange={changePassword} onEnter={ok} type="password" outlined />
            </main>
            <footer>
                { onForgot ? <Button label={tx(forgotLabel)} action={forgot} disabled={!canForgot()}/> : null }
                { loading ? <div className="load-box"><Icon icon="refresh" /></div> : <Button label={tx(loginLabel)} action={ok} disabled={!canOK()} raised /> }
                { message ? <div className="message"><Text>{message}</Text></div> : null}
            </footer>
        </div>
    )
}